module.exports = __webpack_public_path__ + "img/back_05.04f86ba3.png";